/**
 * JSON Merge Patch (RFC 7386), the delta format of contracts/realtime.md: objects merge key by key,
 * `null` removes a key, arrays and scalars replace. Returns a new object; unchanged branches keep
 * their identity so React consumers re-render only what changed.
 */
export function applyMergePatch<T>(target: T, patch: unknown): T {
  if (patch === null || typeof patch !== 'object' || Array.isArray(patch)) return patch as T;
  const base: Record<string, unknown> =
    target !== null && typeof target === 'object' && !Array.isArray(target) ? (target as Record<string, unknown>) : {};
  const out: Record<string, unknown> = { ...base };
  for (const [k, v] of Object.entries(patch as Record<string, unknown>)) {
    if (v === null) delete out[k];
    else out[k] = applyMergePatch(base[k], v);
  }
  return out as T;
}
